export default "__VITE_ASSET__CF1CuAi8__"